import { render, staticRenderFns } from "./CommentActions.vue?vue&type=template&id=3feead25&scoped=true"
import script from "./CommentActions.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentActions.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CommentActions.vue?vue&type=style&index=0&id=3feead25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feead25",
  null
  
)

export default component.exports